/**
 * Email and PDF template types, ported from portal-ui-lib's `email-template.types.ts` /
 * `pdf-template.types.ts`. A template is keyed by type + group + owning org node.
 */

export type BuilderKind = 'email' | 'pdf';

export const TEMPLATE_GROUPS = [
  'TYRE',
  'NEW_CAR',
  'USED_CAR',
  'PROLONGING',
  'KM_CATCH_UP',
] as const;
export type TemplateGroup = (typeof TEMPLATE_GROUPS)[number];

export const EMAIL_TYPES = ['OFFER', 'CUSTOMER_ORDER', 'DEALER_ORDER'] as const;
export type EmailTemplateType = (typeof EMAIL_TYPES)[number];

export const PDF_TYPES = ['TERMS', 'OFFER', 'ORDER'] as const;
export type PdfTemplateType = (typeof PDF_TYPES)[number];

interface StoredTemplate {
  id: string;
  ownerOrgNodeId: string;
  scopeOrgNodeIds: string[];
  /** HTML; variables as `{{key}}`. */
  content: string;
  /** The editor's ProseMirror JSON; preferred when it is a `doc`. */
  designJson: unknown;
  templateGroup?: string | null;
  isActive: boolean;
}

export interface EmailTemplate extends StoredTemplate {
  subject: string;
  templateType: EmailTemplateType;
  fromEmail?: string | null;
  fromName?: string | null;
  bcc?: string[];
}

export interface PdfTemplate extends StoredTemplate {
  templateType: PdfTemplateType;
  description?: string | null;
  pageSize: string;
  orientation: string;
  margins: string;
  header?: string | null;
  footer?: string | null;
  styles?: string | null;
}

export type AnyTemplate = EmailTemplate | PdfTemplate;
